<div class="cardLayout">
  <ion-row>
    <ion-col size>
      <!-- <div class="popup-heading"> -->
      <div class="verticle-center">
        <p class="fs-16 fs_14ForMobile font_regular" *ngIf="!isDisabledEmailContent">Send Wishes</p>
      </div>
      <!-- </div> -->
    </ion-col>
    <ion-col size="auto">
      <div class="popup-close">
        <span [mat-dialog-close] class="fs-30 fs_18ForMobile material-icons popup-close-icon">close</span>
      </div>
    </ion-col>
  </ion-row>

  <mat-dialog-content class="p-0">
  <div class="cardBox">
    <ion-row *ngIf="isHideEmployeeInfo">
      <ion-col size="12">
        <div *ngFor="let data of employeeList">
          <div class="fs-16 fs_14ForMobile font_semibold">{{data.name}}</div>
          <div class="fs-14 fs_12ForMobile font_regular text_gray mt-5">Email: {{data.officialEmail}}</div>
          <div class="fs-14 fs_12ForMobile font_regular text_gray mt-5">Contact: {{data.contactNo}}</div>
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="verticle-center mt-10">
      <ion-col size="12" size-md="auto">
        <div class="fs-16 fs_14ForMobile font_semibold pr-10">Subject:</div>
      </ion-col>

      <ion-col size size-md="9">
        <mat-form-field class="w-100 mat-height40 mat-input-style">
         <input matInput type="text" placeholder="Enter Subject Here..."
       [(ngModel)]="emailSubject"  (keyup)="checkMaxLength(emailSubject)"
       (input)="isCheckEmailSubject($event)"
       [disabled]="isDisabledEmailContent"
       maxlength="255">

        </mat-form-field>
        <div class="fs-14 fs_12ForMobile red font_regular mt-10" *ngIf="!isValidEmailSubject">Enter Subject</div>
      </ion-col>

      <ion-col size="auto">
        <button type="button" class="add_btn center-content"
          [style.background-color]="buttonColorName" (click)="sendWishes()" *ngIf="isHideSendWishBtn">
          <span class="material-icons fs-16 fs_18ForMobile">send</span>
          <span *ngIf="!mobileResponsiveService.hideForMobile" class="fs-14 fs_12ForMobile ml-5">Send</span>
        </button>
      </ion-col>
    </ion-row>

    <ion-row class="verticle-center mt-10">
      <ion-col size="12">
        <div *ngIf="!isDisabledEmailContent">
          <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="emailContentBody">
        </angular-editor>  -->
          <jodit-editor id="htmlDiv" *ngIf="editorConfig && emailContentBody !== undefined" [config]="editorConfig"
            [(ngModel)]="emailContentBody"></jodit-editor>

          <div class="fs-14 fs_12ForMobile red font_regular mt-10" *ngIf="!isValidEmailContentBody">Enter Email Content</div>
        </div>
        <div *ngIf="isDisabledEmailContent" class="show-wishes">
          <div [innerHTML]="emailContentBody"></div>
        </div>
      </ion-col>
    </ion-row>
  </div>
  </mat-dialog-content>
</div>